/**
 * REPORT-SCREENSHOT-HEATMAP.WIDGET.TSX
 * Preview of the slide
 */
import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"
import { AxisState } from "@/redux/axis.types"
import { TopicState } from "@/redux/topic.types"
import DashboardHeatmapWidget from "./dashboard-heatmap.widget"
import { AccountHeatmapResult } from "@/redux/account.types"
import { PAGE_HEATMAP_LIMIT, PageState } from "@/redux/page.types"
import { t } from "i18next"

interface StateProps {
  _session: Session
  axis: AxisState
  page: PageState
  topic: TopicState
}

interface OwnProps {
  filterName: string
  resultsType: AccountHeatmapResult
  screenshot?: any
  nativeFiltersLabels?: {
    gender: string | null
    birthDate: string | null
    companyWelcomeDate: string | null
  }
}

type Props = StateProps & OwnProps

function ReportScreenshotHeatmapWidget(props: Props) {
  return (
    <div
      className="flex-col"
      style={{
        transform: "scale(0.4)",
        transformOrigin: "top left"
      }}>
      <DashboardHeatmapWidget
        isPreview
        offset={props.page.active.heatmapOffset}
        limit={PAGE_HEATMAP_LIMIT}
        filterName={props.filterName}
        resultsType={props.resultsType}
        isReport
      />

      {props.screenshot &&
        (props.screenshot.gender || props.screenshot.birthDate || props.screenshot.companyWelcomeDate) && (
          <div
            style={{
              marginBottom: "-10px",
              fontSize: 12,
              paddingLeft: 4,
              scale: 1 / 0.4
            }}>
            <div style={{ fontSize: 15, fontWeight: "bold" }}>{t("filters_selected")}</div>
            {props.screenshot.gender && props.nativeFiltersLabels?.gender && (
              <div>
                {t("page_type_screenshot_param_gender")}: {props.nativeFiltersLabels.gender}
              </div>
            )}
            {props.screenshot.birthDate && props.nativeFiltersLabels?.birthDate && (
              <div>
                {t("page_type_screenshot_param_birth_date")}: {props.nativeFiltersLabels.birthDate}
              </div>
            )}
            {props.screenshot.companyWelcomeDate && props.nativeFiltersLabels?.companyWelcomeDate && (
              <div>
                {t("page_type_screenshot_param_company_welcome_date")}: {props.nativeFiltersLabels.companyWelcomeDate}
              </div>
            )}
          </div>
        )}
    </div>
  )
}

// "user_gender": "Genre",
// "user_gender_a": "Autre",
// "user_gender_alt": "Genre",
// "user_gender_f": "Femme",
// "user_gender_m": "Homme",

const mapStateToProps = (state) => ({
  _session: state._session,
  axis: state.axis,
  page: state.page,
  topic: state.topic
})

export default connect(mapStateToProps)(ReportScreenshotHeatmapWidget)
